<template>
    <div class="mediicine_detail">
        <div class="mediicine_detail-patientInfo" v-if="type!=='doctor'&&detail.reminderStatus===1">
            <HomePatientBase
                v-if="info.name"
				type="gray"
				toggleArchiveType="button"
				actionClass="patient_button_style"
				:avatar="info.avatar"
				:patient-name="info.name"
				:desc="`${ $status.gender[info.gender] } ${ info.age }岁`"
                :showRight="false"
			/>
        </div>
        <div v-else class="mediicine_detail-header">
            <div class="status" :style="`color:${reminderStatus[detail.reminderStatus]}`">{{reminderStatusText[detail.reminderStatus]}}</div>
            <div class="time">{{$moment(detail.gmtCreate).format('YYYY-MM-DD')}}</div>
        </div>
        <div class="mediicine_detail-content">
            <div class="title">提醒内容</div>
            <div class="content minHeight200">{{detail.reminderContent}}</div>
            <div class="title">提醒时间</div>
            <div class="content ">{{detail.reminderTime}}</div>
            <template v-if="type!=='doctor'&&detail.reminderStatus===1">
                <div class="yifuyao-button" @click="changeStatus(2)">已服药</div>
                <div class="wangji-button" @click="wanngji">忘记服药</div>
            </template>
        </div>
    </div>
</template>
<script>
import HomePatientBase from '../main/components/patient-base.vue'
export default{
    components:{HomePatientBase},
    data(){
        return{
            detail:{},
            reminderStatus:{
                2:'#15C5CE',
                1:'#FFAD0D',
                3:'#FA5151'
            },
            reminderStatusText:{
                1:'未标记',
                2:'已服药', 
                3:'漏服'	
            },
            patientDetail:{}
        }
    },
    computed:{
        detailId(){
            return this.$route.params.id
        },
        info(){
            return this.$route.query.info?JSON.parse(this.$route.query.info):this.patientDetail
        },
        type(){
            return this.$route.query.type
        }
    },
    created(){
        this.getDetail()
    },
    methods:{
        // 获取回显信息
		async getPatientInfo () {
			const res = await this.$api.patient.getPatientInfo(this.detail.patientId)
			if (!res.code) {
				this.patientDetail = res.data
			}
		},
        getDetail(){
            this.$api.patient.patientmedicationreminderDetail(this.detailId).then(({code,data})=>{
                if(!code){
                    this.detail = data
                    if(this.type !== 'doctor'){
                        this.getPatientInfo()
                    }
                }
            })
        },
        wanngji(){
            this.$dialog.confirm({
                message: '确定将此次服药标记为漏服吗？',
                confirmButtonText:'标为漏服'
            })
            .then(() => {
                // on confirm
                this.changeStatus(3)
            })
            .catch(() => {
                // on cancel
            });
        },
        changeStatus(reminderStatus){
            let params = JSON.parse(JSON.stringify(this.detail))
            params['reminderStatus'] = reminderStatus
            this.$api.patient.patientmedicationreminderUpdate(params).then(({code})=>{
                if(!code){
                    if(params.reminderStatus === 2){
                        this.$toast('标记为已服药')
                    }
                    this.getDetail()
                }
            })
        }
    }
}
</script>
<style lang="less">
.mediicine_detail{
    background-color: #F5F6F7;
    &-patientInfo{
        padding: 12px 40px 40px 40px;
    }
    &-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 148px;
        padding: 0 40px;
        .status{
            font-size: 46px;
            font-weight: bold;
        }
        .time{
            font-size: 28px;
            color: #8F959E;
        }
    }
    &-content{
        border-radius: 32px 32px 0px 0px;
        background: #FFFFFF;
        min-height: calc(100vh - 228px);
        padding: 40px;
        .title{
            font-size: 32px;
            font-weight: bold;
            color: #1F2329;
        }
        .minHeight200{
            min-height: 200px;
        }
        .content{
            background: #F5F6F7;
            border-radius: 12px;
            padding: 24px;
            margin-top: 28px;
            font-size: 28px;
            color: #1F2329;
            margin-bottom: 40px;
        }
        .yifuyao-button{
            width: 340px;
            height: 88px;
            line-height: 88px;
            border-radius: 12px;
            margin: 80px auto 24px;
            background: @primary;
            color: #ffffff;
            font-size: 30px;
            text-align: center;
        }
        .wangji-button{
            font-size: 28px;
            color: #2B2F36;
            text-align: center;
        }
    }
}
</style>